"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkUUN3IUQ2_js = require('./chunk-UUN3IUQ2.js');
var chunk356JBGIO_js = require('./chunk-356JBGIO.js');
var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var r = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var r__default = /*#__PURE__*/_interopDefaultLegacy(r);

var i=r__default["default"].button`
  width: 100%;
  border: none;
  border-radius: var(--border-radius-small);
  box-shadow: var(--elevation-100);
  padding: var(--spacing-small) var(--spacing-regular) var(--spacing-small)
    var(--spacing-small);
  background: var(--background-level-1);
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: var(--elevation-200);
    background: var(--background-level-2);
  }

  &:focus-within {
    outline: var(--border-width-small) solid var(--border-link-focus);
  }
`,s=r__default["default"](chunkUUN3IUQ2_js.a).attrs({spacing:"small"})`
  height: 100%;
`,c=r__default["default"](chunk356JBGIO_js.a).attrs({xAlign:"center",yAlign:"center"})`
  background: var(--background-info-base);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-regular);
`,l=r__default["default"](chunk356JBGIO_js.a).attrs({spacing:"none",xAlign:"start"})`
  justify-content: center;
  text-align: left;
`,p=r__default["default"](chunk2VCHSK65_js.d).attrs({forwardedAs:"span",weight:"bold",size:"small",colorToken:"foreground-tertiary",letterSpacing:"spacious"})`
  text-transform: uppercase;
`;var x=({helper:m,cta:g,icon:u,onClick:b})=>jsxRuntime.jsx(i,{onClick:b,children:jsxRuntime.jsxs(s,{children:[jsxRuntime.jsx(c,{children:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{icon:u,size:"large",colorToken:"background-interactive-active-default"})}),jsxRuntime.jsxs(l,{children:[jsxRuntime.jsx(p,{children:m}),jsxRuntime.jsx(chunk2VCHSK65_js.d,{forwardedAs:"span",weight:"semibold",size:"medium",colorToken:"foreground-primary",children:g})]})]})}),f=x;

exports.a = f;
